import { MenuItemV2, type MenuItemV2Props } from "@/components/interactive/MenuItemV2";
import { classNames } from "@/utils/classnames";
import React from "react";

export const SIDENAV_SECTION_TITLE_CLASS =
  "!h-7 !cursor-default !rounded-cds-6 !pl-cds-8 !pr-cds-4 !pt-cds-8 !pb-cds-4 " +
  "!text-cds-ink-subtle text-cds-xs";

const SideNavSectionTitleV2Impl: React.FC<Omit<MenuItemV2Props, "size" | "variant">> = ({
  className,
  ...props
}) => {
  return (
    <MenuItemV2
      size={"md"}
      variant={"title"}
      className={classNames(SIDENAV_SECTION_TITLE_CLASS, className)}
      {...props}
    />
  );
};

export const SideNavSectionTitleV2 = React.memo(SideNavSectionTitleV2Impl);
SideNavSectionTitleV2.displayName = "SideNavSectionTitleV2";
